// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LikeFilledSvg from "@fishx/icons-svg/es/asn/LikeFilled";
import FishxIcon from '../components/FishxIcon';

var LikeFilled = function LikeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LikeFilledSvg
  }));
};

LikeFilled.displayName = 'LikeFilled';
export default React.forwardRef(LikeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LikeFilled.js
// module id = 3040
// module chunks = 0